// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function button1_click(event) {
	$w("#box1").show();
	$w("#box2").hide();
	$w("#box3").hide();
}


/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function button2_click(event) {
	$w("#box2").show();
	$w("#box1").hide();
	$w("#box3").hide();
	
}



/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function button3_click(event) {
	$w("#box3").show();
	$w("#box2").hide();
	$w("#box1").hide();
}